"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[736],{

/***/ 55348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DD": function() { return /* binding */ MediaType; },
/* harmony export */   "GA": function() { return /* binding */ EXTERNAL_PROVIDER; },
/* harmony export */   "xs": function() { return /* binding */ Product; },
/* harmony export */   "zf": function() { return /* binding */ eCommerceTheme; }
/* harmony export */ });
/* unused harmony export ProductStatus */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _components_new_eCommerce_helpers_data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88435);




var eCommerceTheme;
(function(eCommerceTheme) {
    eCommerceTheme["light"] = "light";
    eCommerceTheme["dark"] = "dark";
})(eCommerceTheme || (eCommerceTheme = {}));
var MediaType;
(function(MediaType) {
    MediaType["IMAGE"] = "image";
    MediaType["YOUTUBE"] = "youtube";
    MediaType["HEXA3D"] = "hexa3d";
})(MediaType || (MediaType = {}));
var ProductStatus;
(function(ProductStatus) {
    ProductStatus["ACTIVE"] = "Active";
    ProductStatus["ARCHIVED"] = "Archived";
    ProductStatus["DRAFT"] = "Draft";
})(ProductStatus || (ProductStatus = {}));
var OpticalCenterTypes;
(function(OpticalCenterTypes) {
    OpticalCenterTypes["LUNETTES"] = "Lunettes";
    OpticalCenterTypes["LUNETTES_SOLEIL"] = "Lunettes soleil";
})(OpticalCenterTypes || (OpticalCenterTypes = {}));
var getDefaultPrice = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!data.length) return null;
    var defaultVariant = data.find(function(item) {
        return item.isDefault;
    });
    return (defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.price) || null;
};
var Product = /*#__PURE__*/ function() {
    "use strict";
    function Product() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, userId = arguments.length > 1 ? arguments[1] : void 0;
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Product);
        var ref, ref1, ref2, ref3;
        this.id = model.id || null;
        this.tourId = model.tourId || null;
        this.title = model.title || null;
        this.previewImage = model.previewImage || null;
        this.userId = userId || null;
        this.description = model.description || null;
        this.variants = model.variants || [];
        var customVariant = this.getMinVariant(model.variants, "price");
        var defaultPrice = getDefaultPrice(model.variants);
        this.countryId = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.countryId) || null;
        // this.status = customVariant?.status || null;
        this.weight = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.weight) || null;
        this.weightUnit = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.weightUnit) || null;
        this.isTrackQuantity = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.isTrackQuantity) || false;
        this.quantity = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.quantity) || 0;
        this.sellingOutOfStock = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.sellingOutOfStock) || false;
        this.barcode = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.barcode) || null;
        this.price = defaultPrice || (customVariant === null || customVariant === void 0 ? void 0 : customVariant.price) || null;
        this.comparePrice = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.comparePrice) || null;
        this.isShipping = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.isShipping) || false;
        this.hsCode = (customVariant === null || customVariant === void 0 ? void 0 : customVariant.hsCode) || null;
        this.warrantyFile = model.warrantyFile || null;
        this.specificationsFile = model.specificationsFile || null;
        this.eCommerceVendorId = model.eCommerceVendorId || null;
        this.eCommerceProductTypeId = model.eCommerceProductTypeId || null;
        this.eCommerceExternalProductTypeId = this.setECommerceExternalProductTypeId(model.productType, model.externalProvider);
        this.externalProductId = model.externalProductId || null;
        this.eCommerceExternalProvider = model.externalProvider || null;
        this.isMultipleOptions = model.isMultipleOptions || false;
        this.icon = model.icon || null;
        if (model.icon && ((ref = model.icon) === null || ref === void 0 ? void 0 : ref.indexOf(".")) !== -1) {
            this.iconFile = "".concat("https://cdn.treedis.com", "/users/").concat(this.userId, "/eCommerce/").concat(this.id, "/").concat(model.icon);
            this.icon = null;
        }
        this.opacity = model.opacity || 0;
        this.iconColor = model.iconColor || null;
        this.media = ((ref1 = model.media) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, item), {
                url: _this.getMediaUrl(item.url, item.type),
                embed: item.type === MediaType.YOUTUBE ? item.url : ""
            });
        })) || [];
        this.media = this.saveMediaByUrl(this.media);
        this.specifications = model.specifications || [];
        this.options = model.options || [];
        this.previewImage = this.media.find(function(item) {
            return item.type !== MediaType.YOUTUBE && item.type !== MediaType.HEXA3D;
        }) || {};
        this.sid = model.sid || null;
        this.positionX = model.positionX || null;
        this.positionY = model.positionY || null;
        this.positionZ = model.positionZ || null;
        this.stemVectorX = model.stemVectorX || null;
        this.stemVectorZ = model.stemVectorZ || null;
        this.stemVectorY = model.stemVectorY || null;
        this.status = model.status || null;
        var _isEnableCart;
        this.isEnableCart = (_isEnableCart = model.isEnableCart) !== null && _isEnableCart !== void 0 ? _isEnableCart : false;
        this.cartLink = model.cartLink || "#";
        this.cartLinkType = model.cartLinkType || null;
        var _vat;
        this.vat = (_vat = model.vat) !== null && _vat !== void 0 ? _vat : 0;
        this.tags = (model === null || model === void 0 ? void 0 : model.tags) || [];
        this.productType = (model === null || model === void 0 ? void 0 : (ref2 = model.productType) === null || ref2 === void 0 ? void 0 : ref2.name) || null;
        this.vendor = (model === null || model === void 0 ? void 0 : (ref3 = model.vendor) === null || ref3 === void 0 ? void 0 : ref3.name) || null;
    }
    var _proto = Product.prototype;
    _proto.getMediaUrl = function getMediaUrl(url, type) {
        if (type === MediaType.YOUTUBE) {
            return "https://img.youtube.com/vi/".concat(url, "/sddefault.jpg");
        }
        if (type === MediaType.HEXA3D) {
            if (url.includes("static.fittingbox.com") && url.includes("sku")) {
                var arrayOfLinkParts = url.split("=");
                if (!arrayOfLinkParts[arrayOfLinkParts.length - 1]) {
                    return null;
                }
                return url;
            }
            return url;
        }
        return "".concat("https://cdn.treedis.com", "/users/").concat(this.userId, "/eCommerce/").concat(this.id, "/media/").concat(url);
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.saveMediaByUrl = function saveMediaByUrl(media) {
        var ref;
        var havellsTypeIndex = media === null || media === void 0 ? void 0 : media.findIndex(function(item) {
            return (item === null || item === void 0 ? void 0 : item.type) === MediaType.HEXA3D;
        });
        return ((ref = media[havellsTypeIndex]) === null || ref === void 0 ? void 0 : ref.url) === null ? media.filter(function(_, index) {
            return index !== havellsTypeIndex;
        }) : media;
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.getMinVariant = function getMinVariant() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], field = arguments.length > 1 ? arguments[1] : void 0;
        if (!data.length) return null;
        var filtered = data.filter(function(item) {
            return data.length > 1 && !item.isDefault || data.length === 1;
        });
        return filtered.reduce(function(minItem, item) {
            return item[field] != null && minItem[field] > item[field] ? item : minItem;
        }, filtered[0]);
    };
    // eslint-disable-next-line consistent-return,class-methods-use-this
    _proto.setECommerceExternalProductTypeId = function setECommerceExternalProductTypeId(productType, externalProvider) {
        if (productType === null || productType === void 0 ? void 0 : productType.externalTypeId) {
            return productType === null || productType === void 0 ? void 0 : productType.externalTypeId;
        }
        if (externalProvider === _components_new_eCommerce_helpers_data__WEBPACK_IMPORTED_MODULE_0__/* .ECommerceProductExternalProvider.OPTICAL_CENTER */ .G.OPTICAL_CENTER) {
            return (productType === null || productType === void 0 ? void 0 : productType.name) === OpticalCenterTypes.LUNETTES ? 1 : 2;
        }
        return null;
    };
    return Product;
}();
var EXTERNAL_PROVIDER;
(function(EXTERNAL_PROVIDER) {
    EXTERNAL_PROVIDER["SHOPIFY"] = "shopify";
    EXTERNAL_PROVIDER["OPTICAL_CENTER"] = "opticalCenter";
    EXTERNAL_PROVIDER["HAVELLS"] = "havells";
})(EXTERNAL_PROVIDER || (EXTERNAL_PROVIDER = {}));


/***/ }),

/***/ 71861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qx": function() { return /* binding */ Shipping; }
/* harmony export */ });
/* unused harmony exports ShippingRateConditionType, ShippingProfileType, ShippingZone */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
// eslint-disable-next-line max-classes-per-file

var ShippingRateConditionType;
(function(ShippingRateConditionType) {
    ShippingRateConditionType["WEIGHT"] = "weight";
    ShippingRateConditionType["PRICE"] = "price";
})(ShippingRateConditionType || (ShippingRateConditionType = {}));
var ShippingProfileType;
(function(ShippingProfileType) {
    ShippingProfileType["General"] = "general";
    ShippingProfileType["Custom"] = "custom";
})(ShippingProfileType || (ShippingProfileType = {}));
var ShippingZone = function ShippingZone() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ShippingZone);
    this.id = model.id || null;
    this.name = model.name || null;
    this.countries = model.countries ? model.countries.map(function(country) {
        return country.id;
    }) : [];
    this.isSelectAllCountries = model.isSelectAllCountries || null;
    this.rates = model.rates || [];
};
var Shipping = function Shipping() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Shipping);
    this.id = model.id || null;
    this.name = model.name || null;
    this.type = model.type || null;
    this.zones = model.zones ? model.zones.map(function(zone) {
        return new ShippingZone(zone);
    }) : [];
};


/***/ }),

/***/ 29690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D8": function() { return /* binding */ getBrandOptions; },
/* harmony export */   "GZ": function() { return /* binding */ UniversalOptionAll; },
/* harmony export */   "Gr": function() { return /* binding */ getProductTypeOptions; },
/* harmony export */   "UZ": function() { return /* binding */ DEFAULT_LIMIT; },
/* harmony export */   "VH": function() { return /* binding */ getColorOptions; },
/* harmony export */   "lW": function() { return /* binding */ initialFilters; },
/* harmony export */   "nh": function() { return /* binding */ getSortOptions; },
/* harmony export */   "nv": function() { return /* binding */ transformDataForRequest; },
/* harmony export */   "yw": function() { return /* binding */ DEFAULT_SORT; }
/* harmony export */ });
/* unused harmony exports validateData, filterCbMain */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26132);
/* harmony import */ var _helpers_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41154);





var DEFAULT_SORT = "price";
var DEFAULT_LIMIT = 12;
var unnecesaryKeysForRequest = [
    "liked",
    "err",
    "sort",
    "discount"
];
var UniversalOptionAll = "Any";
var initialFilters = {
    search: "",
    mobileSearch: "",
    minPrice: "",
    maxPrice: "",
    liked: false,
    discount: false,
    brandId: UniversalOptionAll,
    color: UniversalOptionAll,
    productTypeId: UniversalOptionAll,
    sort: _types__WEBPACK_IMPORTED_MODULE_0__/* .ESortOption.priceDesc */ .R.priceDesc,
    err: {}
};
var isConditionExist = function(key, value) {
    return !unnecesaryKeysForRequest.includes(key) && value !== UniversalOptionAll && value !== "";
};
var validateData = function(data) {
    return Object.entries(data).reduce(function(acc, cur) {
        var _cur = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(cur, 2), key = _cur[0], value = _cur[1];
        if (isConditionExist(key, value)) {
            acc[key] = value;
        }
        return acc;
    }, {});
};
var transformDataForRequest = function(data) {
    var actualData = validateData(data);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        search: data.search || data.mobileSearch,
        discount: data.discount || undefined
    }, actualData);
};
var filterCbMain = function(data, favouriteProducts) {
    return function(product) {
        var isViable = true;
        if (data["liked"]) {
            isViable = isViable && checkIsFavourite(favouriteProducts, product);
        }
        if (data["discount"]) {
            isViable = isViable && !!product.comparePrice;
        }
        if (data["minPrice"] && !isNaN(Number(data["minPrice"]))) {
            isViable = isViable && product.price >= Number(data["minPrice"]);
        }
        if (data["maxPrice"] && !isNaN(Number(data["maxPrice"]))) {
            isViable = isViable && product.price <= Number(data["maxPrice"]);
        }
        if (data["brand"] !== UniversalOptionAll) {
            isViable = isViable && product.eCommerceVendorId === data["brand"];
        }
        if (data["color"] !== UniversalOptionAll) {
            var ref;
            isViable = isViable && (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(v) {
                var ref;
                return (v === null || v === void 0 ? void 0 : (ref = v.colorOption) === null || ref === void 0 ? void 0 : ref.value) === data["color"];
            }));
        }
        if (data["productType"] !== UniversalOptionAll) {
            isViable = isViable && product.eCommerceProductTypeId === data["productType"];
        }
        if (data["search"] !== UniversalOptionAll) {
            var ref1, ref2, ref3;
            isViable = isViable && ((ref2 = product === null || product === void 0 ? void 0 : (ref1 = product.title) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === null || ref2 === void 0 ? void 0 : ref2.includes((ref3 = data["search"]) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()));
        }
        return isViable;
    };
};
var getSortOptions = function(translation) {
    return [
        {
            label: translation.priceDesc || "Price Desc.",
            value: _types__WEBPACK_IMPORTED_MODULE_0__/* .ESortOption.priceDesc */ .R.priceDesc
        },
        {
            label: translation.priceAsc || "Price Asc.",
            value: _types__WEBPACK_IMPORTED_MODULE_0__/* .ESortOption.priceAsc */ .R.priceAsc
        }, 
    ];
};
var getBrandOptions = function(translation, filterOptions) {
    var ref;
    return [
        {
            label: translation.optionAny || UniversalOptionAll,
            value: UniversalOptionAll
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(filterOptions === null || filterOptions === void 0 ? void 0 : (ref = filterOptions.vendors) === null || ref === void 0 ? void 0 : ref.map(function(v) {
        return {
            label: v.name,
            value: v.id
        };
    })));
};
var getColorOptions = function(translation, filterOptions) {
    var ref;
    return [
        {
            label: translation.optionAny || UniversalOptionAll,
            value: UniversalOptionAll
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(filterOptions === null || filterOptions === void 0 ? void 0 : (ref = filterOptions.options) === null || ref === void 0 ? void 0 : ref.map(function(o) {
        return {
            label: (o === null || o === void 0 ? void 0 : o.label) || (o === null || o === void 0 ? void 0 : o.value),
            value: o === null || o === void 0 ? void 0 : o.value
        };
    })));
};
var getProductTypeOptions = function(translation, productTypes) {
    return [
        {
            label: translation.optionAny || UniversalOptionAll,
            value: UniversalOptionAll
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((productTypes === null || productTypes === void 0 ? void 0 : productTypes.map(function(pt) {
        return {
            label: pt === null || pt === void 0 ? void 0 : pt.name,
            value: pt === null || pt === void 0 ? void 0 : pt.id
        };
    })) || []));
};


/***/ }),

/***/ 26132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ESortOption; }
/* harmony export */ });
var ESortOption;
(function(ESortOption) {
    ESortOption[ESortOption["priceDesc"] = 0] = "priceDesc";
    ESortOption[ESortOption["priceAsc"] = 1] = "priceAsc";
})(ESortOption || (ESortOption = {}));


/***/ }),

/***/ 88435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ECommerceProductExternalProvider; }
/* harmony export */ });
var ECommerceProductExternalProvider;
(function(ECommerceProductExternalProvider) {
    ECommerceProductExternalProvider["SHOPIFY"] = "shopify";
    ECommerceProductExternalProvider["OPTICAL_CENTER"] = "opticalCenter";
    ECommerceProductExternalProvider["HAVELLS"] = "havells";
})(ECommerceProductExternalProvider || (ECommerceProductExternalProvider = {}));


/***/ }),

/***/ 40736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ECommerceTour; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_iterator.mjs
var _async_iterator = __webpack_require__(2236);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get.mjs + 1 modules
var _get = __webpack_require__(45785);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 153 modules
var dist = __webpack_require__(33050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CssBaseline/CssBaseline.js
var CssBaseline = __webpack_require__(40793);
// EXTERNAL MODULE: ./node_modules/stylis-plugin-rtl/dist/stylis-rtl.js
var stylis_rtl = __webpack_require__(14194);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(74821);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js + 2 modules
var ThemeProvider = __webpack_require__(71927);
// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./_helpers/base.tsx
var base = __webpack_require__(41154);
// EXTERNAL MODULE: ./components/util/sdk.ts + 2 modules
var sdk = __webpack_require__(68687);
// EXTERNAL MODULE: ./components/util/popups.ts
var popups = __webpack_require__(62818);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./_helpers/storage.ts
var storage = __webpack_require__(98144);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
// EXTERNAL MODULE: ./components/tour/BaseTour.tsx + 58 modules
var BaseTour = __webpack_require__(44564);
// EXTERNAL MODULE: ./_helpers/renderDebug.ts
var renderDebug = __webpack_require__(66725);
;// CONCATENATED MODULE: ./components/tour/eCommerce/popups/About.tsx



var About = function(param) {
    var show = param.show, logo = param.logo, description = param.description, rtl = param.rtl, toggleAboutPopup = param.toggleAboutPopup, socials = param.socials;
    if (!show) return null;
    (0,renderDebug/* dLog */.a)("About");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "popup-about ".concat(rtl ? "rtl" : ""),
        id: "about-pop",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "close",
                onClick: toggleAboutPopup,
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-times"
                })
            }),
            logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "about-logo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: logo,
                    alt: "popup-logo"
                })
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "about-title",
                dangerouslySetInnerHTML: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "about-social-icons",
                children: [
                    socials.facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: socials.facebook,
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fab fa-facebook-f"
                        })
                    }),
                    socials.twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: socials.twitter,
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fab fa-twitter"
                        })
                    }),
                    socials.linkedin && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: socials.linkedin,
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fab fa-linkedin-in"
                        })
                    }),
                    socials.instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: socials.instagram,
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fab fa-instagram"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var popups_About = (/*#__PURE__*/(0,react.memo)(About));

;// CONCATENATED MODULE: ./components/tour/eCommerce/header/Header.tsx




var Header = function(param) {
    var tour = param.tour, logoUrl = param.logoUrl, chatToken = param.chatToken, translation = param.translation;
    (0,renderDebug/* dLog */.a)("Header");
    var ref = (0,react.useState)(false), aboutPopupOn = ref[0], setAboutPopupOn = ref[1];
    if (tour.client && tour.client.logo && chatToken) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popups_About, {
            show: aboutPopupOn,
            rtl: tour.client && tour.client.rtl,
            translation: translation,
            description: tour.summary,
            socials: {
                facebook: tour.client && tour.client.facebook,
                instagram: tour.client && tour.client.instagram,
                twitter: tour.client && tour.client.twitter,
                linkedin: tour.client && tour.client.linkedin
            },
            logo: logoUrl,
            toggleAboutPopup: function() {
                return setAboutPopupOn(false);
            }
        })
    });
};
/* harmony default export */ var header_Header = (/*#__PURE__*/(0,react.memo)(Header));

// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_models/eCommerce/Shipping.ts
var Shipping = __webpack_require__(71861);
// EXTERNAL MODULE: ./_models/eCommerce/Product.ts
var Product = __webpack_require__(55348);
// EXTERNAL MODULE: ./components/types.ts
var types = __webpack_require__(31828);
// EXTERNAL MODULE: ./components-new/eCommerce/Store/static.tsx
var Store_static = __webpack_require__(29690);
// EXTERNAL MODULE: ./components-new/common/AudioModule.ts + 2 modules
var AudioModule = __webpack_require__(29519);
// EXTERNAL MODULE: ./components/util/getLocationUrl.ts
var getLocationUrl = __webpack_require__(49058);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
;// CONCATENATED MODULE: ./components/ECommerceTour.tsx
/* eslint-disable no-return-await */ // eslint-disable-next-line no-use-before-define
































// Components










var Products = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(3661)]).then(__webpack_require__.bind(__webpack_require__, 93661));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93661)
            ];
        }
    },
    ssr: false
});
var ProductPopup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(6126), __webpack_require__.e(21)]).then(__webpack_require__.bind(__webpack_require__, 70021));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70021)
            ];
        }
    },
    ssr: false
});
var CartPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4765).then(__webpack_require__.bind(__webpack_require__, 34765));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34765)
            ];
        }
    },
    ssr: false
});
var Checkout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(3376)]).then(__webpack_require__.bind(__webpack_require__, 33376));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33376)
            ];
        }
    },
    ssr: false
});
var ContactMe = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5764).then(__webpack_require__.bind(__webpack_require__, 55764));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55764)
            ];
        }
    },
    ssr: false
});
var Store = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8114), __webpack_require__.e(8069)]).then(__webpack_require__.bind(__webpack_require__, 58069));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58069)
            ];
        }
    },
    ssr: false
});
var SuccessPurchaseScreen = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2243).then(__webpack_require__.bind(__webpack_require__, 82243));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82243)
            ];
        }
    },
    ssr: false
});
var BottomBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6174).then(__webpack_require__.bind(__webpack_require__, 56174));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56174)
            ];
        }
    },
    ssr: false
});
var Sidebar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7186).then(__webpack_require__.bind(__webpack_require__, 57186));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57186)
            ];
        }
    },
    ssr: false
});
var SoundControls = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 67644));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67644)
            ];
        }
    },
    ssr: false
});
var BbWhitelabelBlock = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2143).then(__webpack_require__.bind(__webpack_require__, 42143));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42143)
            ];
        }
    },
    ssr: false
});
var NEAREST_PRODUCTS_BY_CURRENT_POSITION = 5;
var NEARES_PRODUCTS_LIMIT = 15;
var DEFAULT_PAGE = 1;
var DEFAULT_LIMIT = 100;
var TAG = "tag";
var POLYGON = "polygon";
var audioHandler = AudioModule/* AudioModule.getInstance */.w0.getInstance();
var ECommerceTour = /*#__PURE__*/ function(BaseTour) {
    "use strict";
    (0,_inherits/* default */.Z)(ECommerceTour, BaseTour);
    var _super = (0,_create_super/* default */.Z)(ECommerceTour);
    function ECommerceTour(props) {
        (0,_class_call_check/* default */.Z)(this, ECommerceTour);
        var _this;
        _this = _super.call(this, props, Tour/* TourType.ECommerce */.v.ECommerce);
        _this.lastClickedItem = null;
        _this.takeScreenshot = sdk/* takeScreenshot.bind */.ss.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.takePano = sdk/* takePano.bind */.Zy.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.toggleContactPopup = popups/* toggleContactPopup.bind */.O.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.isClickedToTag = false;
        _this.setProductsStateWithDelay = function(products) {
            setTimeout(function() {
                return _this.setState({
                    currentProducts: products.length > 1 ? products : [],
                    currentProduct: products.length === 1 ? products[0] : null
                });
            }, 400);
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.startVideo = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                audioHandler.pauseAllMusic();
                // if tourMusic was playing - pause it
                _this1.setState({
                    videoPlaying: true
                });
                return [
                    2
                ];
            });
        });
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.stopVideo = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var videoResume;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        videoResume = _this2.state.videoResume;
                        if (!videoResume) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            videoResume.play()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        _this2.setState({
                            videoPlaying: false
                        });
                        return [
                            2
                        ];
                }
            });
        });
        _this.getCountries = function() {
            (0,util_all/* fetchData */.rQ)("public/countries/getAll", "GET").then(function(data) {
                if (data.countries) {
                    var countries = _this.state.countries;
                    data.countries.map(function(country) {
                        return countries.set(country.id, country.nicename);
                    });
                    _this.setState({
                        countries: countries
                    });
                }
            });
        };
        _this.getSettings = function(matterId) {
            (0,util_all/* fetchData */.rQ)("public/eCommerce/settings", "GET", {
                params: {
                    matterId: matterId
                }
            }).then(function(param) {
                var status = param.status, data = param.data;
                if (status === 200) {
                    _this.setState({
                        currency: data.currency,
                        activeReel: data.activeReel,
                        isOpenReel: data.isOpenReel,
                        settings: data,
                        contactMeType: data.contactMeType,
                        contactMeIframeLink: data.contactMeIframeLink,
                        contactMeRequiredFields: data.contactMeRequiredFields,
                        externalProvider: data.externalProvider
                    });
                }
            });
        };
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getLocations = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(matterId) {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                TreedisPublicDAO/* default.getLocationsByTour */.Z.getLocationsByTour({
                                    query: {
                                        matterId: matterId
                                    }
                                })
                            ];
                        case 1:
                            res = _state.sent();
                            if (res && res.data) {
                                _this3.setState({
                                    locations: res.data
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(matterId) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.getShipping = function(matterId) {
            (0,util_all/* fetchData */.rQ)("public/eCommerce/shipping/getAll", "GET", {
                params: {
                    matterId: matterId
                }
            }).then(function(data) {
                if (data.shippingProfiles) {
                    _this.setState({
                        shippingProfiles: data.shippingProfiles.map(function(profile) {
                            return new Shipping/* Shipping */.Qx(profile);
                        })
                    });
                }
            });
        };
        var _this4 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getProductsWithPagination = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(options) {
                var userId, tourId, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            _this4.setState({
                                isLoadingProducts: true
                            });
                            userId = options.userId, tourId = options.tourId;
                            if (!userId || !tourId) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                TreedisPublicDAO/* default.getProductsWithPagination */.Z.getProductsWithPagination({
                                    query: (0,_object_spread/* default */.Z)({}, options)
                                })
                            ];
                        case 1:
                            // eslint-disable-next-line consistent-return
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            error = _state.sent();
                            console.warn(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            _this4.setState({
                                isLoadingProducts: false
                            });
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(options) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this5 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setProductsWithPagination = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(options) {
                var response, ref, ref1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this5.getProductsWithPagination(options)
                            ];
                        case 1:
                            response = _state.sent();
                            if (response && (response === null || response === void 0 ? void 0 : response.data)) {
                                ;
                                _this5.setState({
                                    products: ((ref = response.data) === null || ref === void 0 ? void 0 : ref.data.map(function(product) {
                                        return new Product/* Product */.xs(product, options.userId);
                                    })) || [],
                                    pageSize: response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.pageSize
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(options) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this6 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getFavoriteProductsFromApi = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, tour, settings, favoriteProductsIds, response, ref, products, error;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this6.state, tour = _state.tour, settings = _state.settings, favoriteProductsIds = _state.favoriteProductsIds;
                        _state1.label = 1;
                    case 1:
                        _state1.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!favoriteProductsIds.length) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this6.getProductsWithPagination({
                                tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                                userId: tour === null || tour === void 0 ? void 0 : tour.userId,
                                masterTourId: settings === null || settings === void 0 ? void 0 : settings.masterTourId,
                                sortByName: Store_static/* DEFAULT_SORT */.yw,
                                sortByDesc: true,
                                page: DEFAULT_PAGE,
                                limit: DEFAULT_LIMIT,
                                productIds: JSON.stringify(favoriteProductsIds)
                            })
                        ];
                    case 2:
                        response = _state1.sent();
                        if (response === null || response === void 0 ? void 0 : response.data) {
                            ;
                            products = (ref = response === null || response === void 0 ? void 0 : response.data.data) === null || ref === void 0 ? void 0 : ref.map(function(product) {
                                return new Product/* Product */.xs(product, tour === null || tour === void 0 ? void 0 : tour.userId);
                            });
                            _this6.setState({
                                favoriteProducts: products
                            });
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _this6.setState({
                            favoriteProducts: []
                        });
                        _state1.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state1.sent();
                        console.error(error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        var _this7 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getMenuFilterOptions = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(matterId) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (!matterId) return [
                        2
                    ];
                    (0,util_all/* fetchData */.rQ)("public/eCommerce/products/getFilterOptions", "GET", {
                        params: {
                            matterId: matterId,
                            optionId: 2
                        }
                    }).then(function(data) {
                        return _this7.setState({
                            menuFilterOptions: {
                                options: data.options,
                                vendors: (data.vendors || []).filter(function(vendor) {
                                    return vendor.countProducts > 0;
                                })
                            }
                        });
                    }).catch(function(err) {
                        console.error(err.message);
                    });
                    return [
                        2
                    ];
                });
            });
            return function(matterId) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.onAddToCart = function(variant) {
            var matterId = _this.props.matterId;
            var cartProducts = cloneDeep_default()(_this.state.cartProducts) || [];
            if (cartProducts.some(function(item) {
                return variant.id === item.id;
            })) {
                if (variant.isReplace) {
                    cartProducts = cartProducts.filter(function(item) {
                        return variant.id !== item.id;
                    });
                    cartProducts.push(variant);
                } else {
                    cartProducts = cartProducts.map(function(item) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            quantity: variant.id === item.id ? variant.quantity : item.quantity
                        });
                    });
                }
            } else {
                cartProducts.push(variant);
            }
            (0,storage/* storage */.t)("cartProducts").set((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,storage/* storage */.t)("cartProducts").get() || {}), (0,_define_property/* default */.Z)({}, matterId, cartProducts)));
            _this.setState({
                cartProducts: cartProducts
            });
        };
        _this.onChangeCart = function(productId, quantity) {
            var matterId = _this.props.matterId;
            var prevProducts = cloneDeep_default()(_this.state.cartProducts) || [];
            var cartProducts = prevProducts.filter(function(item) {
                return productId !== item.id || quantity !== 0 && productId === item.id;
            }).map(function(item) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                    quantity: productId === item.id ? quantity : item.quantity
                });
            });
            (0,storage/* storage */.t)("cartProducts").set((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,storage/* storage */.t)("cartProducts").get() || {}), (0,_define_property/* default */.Z)({}, matterId, cartProducts)));
            _this.setState({
                cartProducts: cartProducts
            });
        };
        // CALLBACKS TO AVOID RENDERS
        _this.openCart = function() {
            return _this.setState({
                cartOpen: true
            });
        };
        _this.openCartAndCloseModal = function() {
            _this.setState({
                cartOpen: true,
                currentProduct: null
            });
        };
        _this.openShare = function() {
            return _this.setState(function(param) {
                var sharePopupOn = param.sharePopupOn;
                return {
                    sharePopupOn: !sharePopupOn
                };
            });
        };
        _this.openCheckout = function() {
            return _this.setState({
                checkoutOpen: true
            });
        };
        _this.openContactMe = function() {
            return _this.setState({
                contactMeOpen: true
            });
        };
        _this.openSuccessPurchaseScreen = function() {
            _this.setState({
                cartOpen: false,
                checkoutOpen: false,
                successPurchaseScreenOpen: true
            });
        };
        _this.openStore = function() {
            return _this.setState({
                storeOpen: true
            });
        };
        _this.backCheckout = function() {
            return _this.setState({
                checkoutOpen: false
            });
        };
        _this.closeCart = function() {
            return _this.setState({
                cartOpen: false
            });
        };
        _this.closeCheckout = function() {
            _this.setState({
                cartOpen: false
            });
            _this.setState({
                checkoutOpen: false
            });
        };
        _this.closeContactMe = function() {
            return _this.setState({
                contactMeOpen: false
            });
        };
        _this.closeProductPopup = function() {
            _this.setState({
                currentProduct: false,
                isShowProduct: false,
                isFromCart: false,
                openedCartProductId: null
            });
        };
        _this.closeProductsPopup = function() {
            _this.setState({
                currentProducts: false,
                isShowProducts: false
            });
        };
        _this.closeSuccessPurchaseScreen = function() {
            return _this.setState({
                successPurchaseScreenOpen: false
            });
        };
        _this.closeStore = function() {
            return _this.setState({
                storeOpen: false
            });
        };
        _this.clearCart = function() {
            var matterId = _this.props.matterId;
            // const { tour } = this.state;
            // this.getTour({ id: matterId });
            // this.loadData(tour);
            var storageCartProducts = (0,storage/* storage */.t)("cartProducts").get() || {};
            (0,storage/* storage */.t)("cartProducts").set(Object.keys(storageCartProducts).reduce(function(acc, key) {
                if (key !== matterId) acc[key] = storageCartProducts[key];
                return acc;
            }, {}));
            _this.setState({
                cartProducts: []
            });
        };
        _this.handleSoundControlClose = function() {
            _this.setState({
                otherPlaying: false
            });
        };
        _this.showMinimapClick = function() {
            return _this.setState(function(param) {
                var minimapVisible = param.minimapVisible;
                return {
                    minimapVisible: !minimapVisible
                };
            });
        };
        _this.showPanoramaClick = function() {
            return _this.setState(function(param) {
                var panoramaOn = param.panoramaOn;
                return {
                    panoramaOn: !panoramaOn,
                    panoramaStart: false
                };
            });
        };
        _this.onHelpClick = function() {
            return _this.setState({
                showHelpModal: true,
                showTermsModal: false
            });
        };
        _this.onTermsClick = function() {
            return _this.setState({
                showHelpModal: false,
                showTermsModal: true
            });
        };
        var _this8 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getSetting = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(setting) {
                var ref, ref1, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (ref = _this8.showcase) === null || ref === void 0 ? void 0 : (ref1 = ref.Settings) === null || ref1 === void 0 ? void 0 : ref1.get(setting)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2,
                                null
                            ];
                    }
                });
            });
            return function(setting) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.toggleGameBook = function() {
            _this.setState(function(param) {
                var showBook = param.showBook;
                return {
                    showBook: !showBook
                };
            });
        };
        _this.toggleMenu = function() {
            _this.setState(function(param) {
                var menuOpen = param.menuOpen;
                return {
                    menuOpen: !menuOpen
                };
            });
        };
        _this.handleMeasureClick = function() {
            if (_this.state.panoramaOn) _this.showPanoramaClick();
            _this.measurementsMode();
        };
        var _this9 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.openProduct = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(initialProduct) {
                var product, ref, ref1, tagSid;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this9.setState({
                                isShowProduct: true,
                                isShowProducts: false
                            });
                            product = (0,_object_spread/* default */.Z)({}, initialProduct);
                            if (!product) return [
                                3,
                                3
                            ];
                            tagSid = (ref = product.tags) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.sid;
                            if (!tagSid) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this9.navigateToTag(tagSid)
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _this9.setState({
                                currentProduct: product
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            console.error("Product select error ecommerceTour => openProduct", initialProduct, product);
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(initialProduct) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.openProductWithDelay = function(initialProduct) {
            _this.setState({
                isShowProducts: false
            });
            var product = (0,_object_spread/* default */.Z)({}, initialProduct);
            if (product) {
                _this.setState({
                    isShowProduct: false,
                    currentProduct: null
                }); // delay to unmount compoenent
                setTimeout(function() {
                    _this.setState({
                        currentProduct: product,
                        isShowProduct: true
                    });
                }, 100);
            }
        };
        _this.onChangeToFavorite = function(product) {
            var isMenu = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var currentProduct = _this.state.currentProduct;
            var targetProduct = product || currentProduct;
            if ((0,base/* checkIsFavourite */.nA)(_this.state.favoriteProductsIds, targetProduct)) {
                _this.onDeleteFromFavorite(targetProduct);
                return;
            }
            _this.onAddToFavorite(targetProduct);
            (0,util/* sendToGA */.o$)("event", {
                eventCategory: isMenu ? "vCommerceLikeMenu" : "vCommerceLike",
                eventAction: "click",
                eventLabel: targetProduct === null || targetProduct === void 0 ? void 0 : targetProduct.title,
                eventId: targetProduct.id
            });
        };
        _this.state = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state), {
            currentProducts: null,
            cartOpen: false,
            checkoutOpen: false,
            contactMeOpen: false,
            contactMeIframeLink: null,
            contactMeRequiredFields: [],
            contactMeType: null,
            successPurchaseScreenOpen: false,
            storeOpen: false,
            cartProducts: [],
            menuFilterOptions: {
                vendors: [],
                options: []
            },
            countries: new Map(),
            currency: {
                symbol: "$",
                code: "USD"
            },
            shippingProfiles: [],
            favoriteProductsIds: [],
            favoriteProducts: [],
            allNearestProducts: [],
            menuProductsInfo: null,
            containerId: "ecommerce",
            activeReel: null,
            settings: {},
            locations: [],
            externalProvider: null,
            pageSize: null,
            isLoadingProduct: false,
            isLoadingProducts: false,
            isActiveNearProducts: false,
            cameraPositionX: null,
            cameraPositionY: null,
            cameraPositionZ: null,
            isShowProducts: false,
            isShowProduct: false,
            productCountState: {},
            isFromCart: false,
            openedCartProductId: null
        });
        _this.navigateToTag = sdk/* navigateToTag.bind */.h_.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.preventTagAction = sdk/* preventTagAction.bind */.$v.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = ECommerceTour.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _props = this.props, tour = _props.tour, matterId = _props.matterId, tourData = _props.tourData;
        var url = (0,getLocationUrl/* getLocationUrl */.v)();
        if (tour) {
            // preview of the tour, load from props
            this.loadData(tour);
        } else {
            this.getTour({
                slug: matterId,
                tourData: tourData,
                url: url
            });
        }
        this.getCountries();
        this.getProductCount();
        this.getMenuFilterOptions(matterId);
        this.getShipping(matterId);
        this.getSettings(matterId);
        this.getLocations(matterId);
        var favoriteProductsIds = (0,storage/* storage */.t)("favoriteProductsIds").get() || {};
        var cartProducts = this.filterProducts((0,storage/* storage */.t)("cartProducts").get() || {});
        this.setState({
            favoriteProductsIds: favoriteProductsIds[matterId] || [],
            cartProducts: cartProducts[matterId] || []
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("keydown", this.takePosition);
        document.removeEventListener("contextmenu", this.disableContext);
        if (socket/* default */.Z) {
            socket/* default.removeAllListeners */.Z.removeAllListeners();
            socket/* default.disconnect */.Z.disconnect();
        }
    };
    _proto.getProductCount = function getProductCount() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var _props, tour, response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _props = _this.props, tour = _props.tourData.tour;
                        return [
                            4,
                            TreedisPublicDAO/* default.getProductsCount */.Z.getProductsCount({
                                query: {
                                    tourId: tour.id
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        _this.setState({
                            productCountState: response.products
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.filterProducts = function filterProducts(products) {
        var newProducts = {};
        Object.keys(products).forEach(function(slug) {
            var filteredProducts = (products[slug] || []).filter(function(product) {
                return product === null || product === void 0 ? void 0 : product.id;
            });
            newProducts[slug] = filteredProducts.length ? filteredProducts : [];
        });
        return newProducts;
    };
    _proto.loadedShowcaseHandler = function loadedShowcaseHandler() {
        var _this = this;
        var _this1 = this, _superprop_get_loadedShowcaseHandler = function() {
            return (0,_get/* default */.Z)((0,_get_prototype_of/* default */.Z)(ECommerceTour.prototype), "loadedShowcaseHandler", _this);
        };
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _superprop_get_loadedShowcaseHandler().call(_this1, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var ref, ref1, _state, tour, externalProvider, isActiveNearProducts, isShowNearestProducts, cameraPositionX, cameraPositionY, cameraPositionZ, isEcommerceTour, ref2, x, y, z;
                                return (0,tslib_es6.__generator)(this, function(_state1) {
                                    switch(_state1.label){
                                        case 0:
                                            _state = _this1.state, tour = _state.tour, externalProvider = _state.externalProvider, isActiveNearProducts = _state.isActiveNearProducts, isShowNearestProducts = _state.isShowNearestProducts, cameraPositionX = _state.cameraPositionX, cameraPositionY = _state.cameraPositionY, cameraPositionZ = _state.cameraPositionZ;
                                            isEcommerceTour = tour.mode === Tour/* TourType.ECommerce */.v.ECommerce;
                                            return [
                                                4,
                                                (0,dist/* iTHREE */.Sc)()
                                            ];
                                        case 1:
                                            _this1.THREE = _state1.sent();
                                            _this1.threeMatrix4 = new _this1.THREE.Matrix4();
                                            _this1.threeFrustum = new _this1.THREE.Frustum();
                                            _this1.threeVector3 = new _this1.THREE.Vector3();
                                            ref2 = ((ref = _this1.camera) === null || ref === void 0 ? void 0 : (ref1 = ref.parent) === null || ref1 === void 0 ? void 0 : ref1.position) || {}, x = ref2.x, y = ref2.y, z = ref2.z;
                                            _this1.showcase.App.state.subscribe(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            if (!(isShowNearestProducts && isActiveNearProducts && x !== cameraPositionX && y !== cameraPositionY && z !== cameraPositionZ)) return [
                                                                3,
                                                                2
                                                            ];
                                                            return [
                                                                4,
                                                                _this1.getAllNearestProduct()
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            _state.label = 2;
                                                        case 2:
                                                            if (!(externalProvider !== types/* ExternalProvider.OPTICAL_CENTER */.FX.OPTICAL_CENTER && isEcommerceTour && isActiveNearProducts)) return [
                                                                3,
                                                                4
                                                            ];
                                                            return [
                                                                4,
                                                                _this1.getNearestProducts()
                                                            ];
                                                        case 3:
                                                            _state.sent();
                                                            _state.label = 4;
                                                        case 4:
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            }));
                                            _this1.showcase.on(_this1.showcase.Mattertag.Event.CLICK, function(tagSid) {
                                                if (!_this1.isClickedToTag) {
                                                    _this1.getProductsByTag(tagSid);
                                                }
                                            });
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    // eslint-disable-next-line consistent-return
    _proto.getAllNearestProduct = function getAllNearestProduct() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, _props, tour, settings, ref3, x, y, z, query, response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!(_this.camera && ((ref = _this.camera) === null || ref === void 0 ? void 0 : ref.parent))) return [
                            3,
                            2
                        ];
                        _props = _this.props, tour = _props.tourData.tour;
                        settings = _this.state.settings;
                        ref3 = ((ref1 = _this.camera) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.parent) === null || ref2 === void 0 ? void 0 : ref2.position) || {}, x = ref3.x, y = ref3.y, z = ref3.z;
                        query = {
                            positionX: x,
                            positionY: y,
                            positionZ: z,
                            radius: NEAREST_PRODUCTS_BY_CURRENT_POSITION,
                            tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                            userId: tour === null || tour === void 0 ? void 0 : tour.userId
                        };
                        if (settings === null || settings === void 0 ? void 0 : settings.masterTourId) {
                            query.masterTourId = settings === null || settings === void 0 ? void 0 : settings.masterTourId;
                        }
                        return [
                            4,
                            TreedisPublicDAO/* default.getNearestProducts */.Z.getNearestProducts({
                                query: query
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response && (response === null || response === void 0 ? void 0 : response.products)) {
                            _this.setState({
                                allNearestProducts: (response === null || response === void 0 ? void 0 : response.products) || [],
                                cameraPositionX: x,
                                cameraPositionY: y,
                                cameraPositionZ: z
                            });
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.openProductPopup = function openProductPopup(type, id) {
        var foundCountOfProduct;
        var _state = this.state, productCountState = _state.productCountState, allTags = _state.allTags;
        var foundTag = Array.from(allTags).find(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), item = _param[1];
            return item.sid === id || item.defaultSid === id;
        });
        // @ts-ignore
        if (type === TAG && (foundTag === null || foundTag === void 0 ? void 0 : foundTag.length) === 2) {
            var ref;
            foundCountOfProduct = +((ref = productCountState.tags.find(function(item) {
                return item.sid === foundTag[1].defaultSid;
            })) === null || ref === void 0 ? void 0 : ref.count);
        }
        if (type === POLYGON) {
            var ref1;
            foundCountOfProduct = +((ref1 = productCountState.polygons.find(function(item) {
                return item.id === id;
            })) === null || ref1 === void 0 ? void 0 : ref1.count);
        }
        if (foundCountOfProduct > 1) {
            this.setState({
                isShowProducts: true
            });
        }
        if (foundCountOfProduct === 1) {
            this.setState({
                isShowProduct: true
            });
        }
    };
    _proto.getProductsByTag = function getProductsByTag(tagSid) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var _state, tour, settings, products, tagsArray, tag, result, error;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _this.isClickedToTag = true;
                        _state1.label = 1;
                    case 1:
                        _state1.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        _this.openProductPopup(TAG, tagSid);
                        _this.setState({
                            isLoadingProduct: true
                        });
                        _state = _this.state, tour = _state.tour, settings = _state.settings;
                        _this.lastClickedItem = null;
                        products = [];
                        tagsArray = Array.from(_this.state.allTags);
                        tag = tagsArray.map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), item = _param[1];
                            return item;
                        }).find(function(item) {
                            return item.sid === tagSid || item.defaultSid === tagSid;
                        }) || null;
                        return [
                            4,
                            TreedisPublicDAO/* default.getProductsByTag */.Z.getProductsByTag({
                                query: {
                                    tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                                    userId: tour === null || tour === void 0 ? void 0 : tour.userId,
                                    masterTourId: settings === null || settings === void 0 ? void 0 : settings.masterTourId,
                                    tagSid: (tag === null || tag === void 0 ? void 0 : tag.defaultSid) || (tag === null || tag === void 0 ? void 0 : tag.sid)
                                }
                            })
                        ];
                    case 2:
                        result = _state1.sent();
                        if (result && (result === null || result === void 0 ? void 0 : result.data)) {
                            products = result.data.map(function(product) {
                                return new Product/* Product */.xs(product, tour === null || tour === void 0 ? void 0 : tour.userId);
                            });
                        }
                        if (products && products.length > 0) {
                            _this.lastClickedItem = tag;
                            _this.setProductsStateWithDelay(products);
                            window.location.hash = tagSid;
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state1.sent();
                        console.error(error);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        _this.isClickedToTag = false;
                        _this.setState({
                            isLoadingProduct: false
                        });
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    // eslint-disable-next-line consistent-return
    _proto.getContaintsPoint = function getContaintsPoint(element) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var positionX, positionY, positionZ;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        positionX = element.positionX, positionY = element.positionY, positionZ = element.positionZ;
                        _this.threeVector3.set(positionX, positionY, positionZ);
                        return [
                            4,
                            _this.getDistanceToPoint(element)
                        ];
                    case 1:
                        if (_state.sent() <= NEAREST_PRODUCTS_BY_CURRENT_POSITION) {
                            return [
                                2,
                                _this.threeFrustum.containsPoint(_this.threeVector3)
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.getNearestProducts = function getNearestProducts() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var _state, externalProvider, allTags, tour, allNearestProducts, allTagsArray, nearestProducts, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err, transformProduct;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this.state, externalProvider = _state.externalProvider, allTags = _state.allTags, tour = _state.tour, allNearestProducts = _state.allNearestProducts;
                        if (externalProvider === types/* ExternalProvider.OPTICAL_CENTER */.FX.OPTICAL_CENTER) return [
                            2
                        ];
                        allTagsArray = Array.from(allTags.values());
                        nearestProducts = [];
                        if (!(_this.camera && allNearestProducts.length)) return [
                            3,
                            13
                        ];
                        _this.threeFrustum.setFromProjectionMatrix(_this.threeMatrix4.multiplyMatrices(_this.camera.projectionMatrix, _this.camera.matrixWorldInverse));
                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                        _state1.label = 1;
                    case 1:
                        _state1.trys.push([
                            1,
                            7,
                            8,
                            13
                        ]);
                        _loop = function() {
                            var _value, product, ref, ref1, ref2, productTagSid, tag, containsPoint, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step1, _value1, polygon, containsPoint1, err;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _value = _step.value;
                                        product = _value;
                                        productTagSid = (ref = product.tags) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.sid;
                                        if (!productTagSid) return [
                                            3,
                                            2
                                        ];
                                        tag = allTagsArray.find(function(item) {
                                            return (item === null || item === void 0 ? void 0 : item.sid) === productTagSid || (item === null || item === void 0 ? void 0 : item.defaultSid) === productTagSid;
                                        });
                                        if (!tag) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            _this.getContaintsPoint(tag)
                                        ];
                                    case 1:
                                        containsPoint = _state.sent();
                                        if (containsPoint) {
                                            nearestProducts.push(product);
                                        }
                                        _state.label = 2;
                                    case 2:
                                        if (!(nearestProducts.length <= NEARES_PRODUCTS_LIMIT && ((ref2 = product.polygons) === null || ref2 === void 0 ? void 0 : ref2.length))) return [
                                            3,
                                            15
                                        ];
                                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                                        _state.label = 3;
                                    case 3:
                                        _state.trys.push([
                                            3,
                                            9,
                                            10,
                                            15
                                        ]);
                                        _iterator = (0,_async_iterator/* default */.Z)(product.polygons);
                                        _state.label = 4;
                                    case 4:
                                        return [
                                            4,
                                            _iterator.next()
                                        ];
                                    case 5:
                                        if (!(_iteratorAbruptCompletion = !(_step1 = _state.sent()).done)) return [
                                            3,
                                            8
                                        ];
                                        _value1 = _step1.value;
                                        polygon = _value1;
                                        return [
                                            4,
                                            _this.getContaintsPoint(polygon)
                                        ];
                                    case 6:
                                        containsPoint1 = _state.sent();
                                        if (containsPoint1) {
                                            nearestProducts.push(product);
                                        }
                                        _state.label = 7;
                                    case 7:
                                        _iteratorAbruptCompletion = false;
                                        return [
                                            3,
                                            4
                                        ];
                                    case 8:
                                        return [
                                            3,
                                            15
                                        ];
                                    case 9:
                                        err = _state.sent();
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                        return [
                                            3,
                                            15
                                        ];
                                    case 10:
                                        _state.trys.push([
                                            10,
                                            ,
                                            13,
                                            14
                                        ]);
                                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                            3,
                                            12
                                        ];
                                        return [
                                            4,
                                            _iterator.return()
                                        ];
                                    case 11:
                                        _state.sent();
                                        _state.label = 12;
                                    case 12:
                                        return [
                                            3,
                                            14
                                        ];
                                    case 13:
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                        return [
                                            7
                                        ];
                                    case 14:
                                        return [
                                            7
                                        ];
                                    case 15:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = (0,_async_iterator/* default */.Z)(allNearestProducts);
                        _state1.label = 2;
                    case 2:
                        return [
                            4,
                            _iterator.next()
                        ];
                    case 3:
                        if (!(_iteratorAbruptCompletion = !(_step = _state1.sent()).done)) return [
                            3,
                            6
                        ];
                        return [
                            5,
                            (0,tslib_es6.__values)(_loop())
                        ];
                    case 4:
                        _state1.sent();
                        _state1.label = 5;
                    case 5:
                        _iteratorAbruptCompletion = false;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            13
                        ];
                    case 7:
                        err = _state1.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 8:
                        _state1.trys.push([
                            8,
                            ,
                            11,
                            12
                        ]);
                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            _iterator.return()
                        ];
                    case 9:
                        _state1.sent();
                        _state1.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                        return [
                            7
                        ];
                    case 12:
                        return [
                            7
                        ];
                    case 13:
                        transformProduct = nearestProducts.map(function(item) {
                            return new Product/* Product */.xs(item, tour === null || tour === void 0 ? void 0 : tour.userId);
                        });
                        _this.setState({
                            nearestProducts: uniqBy_default()(transformProduct, "id")
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.getDistanceToPoint = function getDistanceToPoint(item) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.getDistanceTwoPoint(_this.pose.position, {
                                x: item.positionX,
                                y: item.positionY,
                                z: item.positionZ
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        })();
    };
    // CALLBACKS TO AVOID RENDERS END
    _proto.renderBottomBar = function renderBottomBar(isFullScreen, toggleFullscreen) {
        var _this = this;
        var ref;
        var _state = this.state, favoriteProductsIds = _state.favoriteProductsIds, favoriteProducts = _state.favoriteProducts, nearestProducts = _state.nearestProducts, currency = _state.currency, cartProducts = _state.cartProducts, translation = _state.translation, activeSweepGroup = _state.activeSweepGroup, tour = _state.tour, panoramaOn = _state.panoramaOn, settings = _state.settings, reel = _state.reel, reelStep = _state.reelStep, currentFloor = _state.currentFloor, mpFloors = _state.mpFloors, chatToken = _state.chatToken, activeReel = _state.activeReel, isOpenReel = _state.isOpenReel, tourMode = _state.tourMode, tourPlaying = _state.tourPlaying, minimapVisible = _state.minimapVisible, videoPlaying = _state.videoPlaying, currentSweep = _state.currentSweep, clickedTag = _state.clickedTag;
        var firstAudio = audioHandler.getFirstMusic();
        var audio;
        if ((firstAudio === null || firstAudio === void 0 ? void 0 : firstAudio.type.name) === AudioModule/* MusicObjectKey.TAGS */.NO.TAGS) {
            audio = firstAudio.audio;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                clickedTag && audio && !(audio === null || audio === void 0 ? void 0 : (ref = audio.src) === null || ref === void 0 ? void 0 : ref.includes("/sweeps/")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundControls, {
                    audio: audio,
                    onClose: this.handleSoundControlClose
                }),
                !this.state.showIntro && !this.state.startScreenOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomBar, {
                    translation: translation,
                    isFull: isFullScreen,
                    changeFull: toggleFullscreen,
                    tourMode: tourMode,
                    loadModel: this.loadModel,
                    tour: tour,
                    playTour: this.playTour,
                    tourPlaying: tourPlaying,
                    changeViewMode: this.changeViewMode,
                    panoramaOn: panoramaOn,
                    moveToStep: this.moveToStep,
                    changeFloor: this.changeFloor,
                    showPanorama: tour.panorama && !chatToken,
                    toggleExternalPopup: this.toggleExternalPopup,
                    showPanoramaClick: this.showPanoramaClick,
                    cartProducts: cartProducts,
                    nearestProducts: nearestProducts,
                    openProduct: this.openProduct,
                    openVR: this.openVR,
                    currentFloor: currentFloor,
                    currency: currency,
                    activeReel: activeReel,
                    isOpenReel: isOpenReel,
                    reel: reel,
                    reelStep: reelStep,
                    activeSweepGroup: activeSweepGroup,
                    mpFloors: mpFloors,
                    favoriteProductsIds: favoriteProductsIds,
                    favoriteProducts: favoriteProducts,
                    onChangeFavourite: this.onChangeToFavorite,
                    getSetting: this.getSetting,
                    openCart: this.openCart,
                    openContactMe: this.openContactMe,
                    theme: settings === null || settings === void 0 ? void 0 : settings.theme,
                    onStopVideo: this.stopVideo,
                    showMinimapClick: this.showMinimapClick,
                    videoPlaying: videoPlaying,
                    minimapVisible: minimapVisible,
                    isOpticalCenter: this.state.externalProvider === types/* ExternalProvider.OPTICAL_CENTER */.FX.OPTICAL_CENTER,
                    settings: settings,
                    handleMeasureClick: this.handleMeasureClick,
                    currentSweep: currentSweep,
                    handleNearProductStatus: function(state) {
                        return _this.setState({
                            isActiveNearProducts: state
                        });
                    },
                    getFavoriteProductsFromApi: this.getFavoriteProductsFromApi,
                    handleProductIdForPopup: function(state, id) {
                        return _this.setState({
                            isFromCart: state,
                            openedCartProductId: id
                        });
                    }
                })
            ]
        });
    };
    _proto.handlePolygonProduct = function handlePolygonProduct(polygon) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var products, _state, tour, settings, result, error;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state1.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        _this.openProductPopup(POLYGON, polygon === null || polygon === void 0 ? void 0 : polygon.id);
                        _this.setState({
                            isLoadingProduct: true
                        });
                        products = [];
                        _state = _this.state, tour = _state.tour, settings = _state.settings;
                        return [
                            4,
                            TreedisPublicDAO/* default.getProductsByPolygon */.Z.getProductsByPolygon({
                                query: {
                                    tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                                    userId: tour === null || tour === void 0 ? void 0 : tour.userId,
                                    masterTourId: settings === null || settings === void 0 ? void 0 : settings.masterTourId,
                                    polygonId: polygon === null || polygon === void 0 ? void 0 : polygon.id
                                }
                            })
                        ];
                    case 1:
                        result = _state1.sent();
                        if (result && (result === null || result === void 0 ? void 0 : result.data)) {
                            products = result.data.map(function(product) {
                                return new Product/* Product */.xs(product, tour === null || tour === void 0 ? void 0 : tour.userId);
                            });
                        }
                        _this.lastClickedItem = polygon;
                        _this.setProductsStateWithDelay(products);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state1.sent();
                        console.error(error);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _this.setState({
                            isLoadingProduct: false
                        });
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.handleVSProduct = function handleVSProduct(vsObject) {
        var _this = this;
        var products = (vsObject === null || vsObject === void 0 ? void 0 : vsObject.products.map(function(item) {
            return new Product/* Product */.xs(item, _this.state.tour.userId);
        })) || [];
        if (products.length > 1) {
            this.setState({
                isShowProducts: true
            });
        }
        if (products.length === 1) {
            this.setState({
                isShowProduct: true
            });
        }
        this.setState({
            currentProducts: products.length > 1 ? products : [],
            currentProduct: products.length === 1 ? products[0] : null
        });
    };
    _proto.onAddToFavorite = function onAddToFavorite(product) {
        var matterId = this.props.matterId;
        var favoriteProducts = this.state.favoriteProducts;
        var favoriteProductsIds = cloneDeep_default()(this.state.favoriteProductsIds) || [];
        favoriteProductsIds.push(product === null || product === void 0 ? void 0 : product.id);
        (0,storage/* storage */.t)("favoriteProductsIds").set((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,storage/* storage */.t)("favoriteProductsIds").get() || {}), (0,_define_property/* default */.Z)({}, matterId, favoriteProductsIds)));
        this.setState({
            favoriteProductsIds: favoriteProductsIds,
            favoriteProducts: (0,_to_consumable_array/* default */.Z)(favoriteProducts).concat([
                product
            ])
        });
    };
    _proto.onDeleteFromFavorite = function onDeleteFromFavorite(product) {
        var matterId = this.props.matterId;
        var favoriteProducts = this.state.favoriteProducts;
        var favoriteProductsIds = cloneDeep_default()(this.state.favoriteProductsIds) || [];
        var productsIds = favoriteProductsIds.filter(function(favoriteProductId) {
            return favoriteProductId !== product.id;
        });
        (0,storage/* storage */.t)("favoriteProductsIds").set((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,storage/* storage */.t)("favoriteProductsIds").get() || {}), (0,_define_property/* default */.Z)({}, matterId, productsIds)));
        this.setState({
            favoriteProductsIds: productsIds,
            favoriteProducts: favoriteProducts.filter(function(item) {
                return item.id !== product.id;
            })
        });
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.getDistanceTwoPoint = function getDistanceTwoPoint(originalPosition, targetPosition) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var THREE, cameraDistance, target, original;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,dist/* iTHREE */.Sc)()
                        ];
                    case 1:
                        THREE = _state.sent();
                        cameraDistance = new THREE.Vector3();
                        target = new THREE.Vector3(targetPosition.x, targetPosition.y, targetPosition.z);
                        original = new THREE.Vector3(originalPosition.x, originalPosition.y, originalPosition.z);
                        cameraDistance.subVectors(original, target);
                        return [
                            2,
                            cameraDistance.length()
                        ];
                }
            });
        })();
    };
    _proto.injectChildComponents = function injectChildComponents() {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        var _state = this.state, tour = _state.tour, panoramaOn = _state.panoramaOn, chatToken = _state.chatToken, whiteLabelData = _state.whiteLabelData, currentProducts = _state.currentProducts, cartOpen = _state.cartOpen, checkoutOpen = _state.checkoutOpen, contactMeOpen = _state.contactMeOpen, successPurchaseScreenOpen = _state.successPurchaseScreenOpen, storeOpen = _state.storeOpen, translation = _state.translation, currency = _state.currency, products = _state.products, tourEmail = _state.tourEmail, mainPlaying = _state.mainPlaying, currentFloor = _state.currentFloor, sharePopupOn = _state.sharePopupOn, isVSEnabled = _state.isVSEnabled, tourType = _state.tourType, settings = _state.settings, minimapVisible = _state.minimapVisible, game = _state.game, showBook = _state.showBook, menuOpen = _state.menuOpen, cartProducts = _state.cartProducts, showcaseLoaded = _state.showcaseLoaded, isShowProducts = _state.isShowProducts, isShowProduct = _state.isShowProduct, isFromCart = _state.isFromCart, openedCartProductId = _state.openedCartProductId;
        var theme = (0,createTheme/* default */.Z)({
            direction: (tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.rtl) ? "rtl" : undefined,
            // @ts-ignore
            palette: {
                mode: (settings === null || settings === void 0 ? void 0 : settings.theme) || Product/* eCommerceTheme.light */.zf.light
            }
        });
        var isHasFloorMusic = (ref1 = tour.musics) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
            return item.floor === currentFloor + 1;
        });
        return(// @ts-ignore
        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* StyleSheetManager */.LC, {
            stylisPlugins: (0,_to_consumable_array/* default */.Z)((tour === null || tour === void 0 ? void 0 : (ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.rtl) ? [
                stylis_rtl/* default */.ZP
            ] : []),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
                theme: theme,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CssBaseline/* default */.ZP, {}),
                    (this.state.isLoadingProducts || this.state.isLoadingProduct) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginTop: "calc(50vh - 50px)",
                            marginLeft: "calc(50vw - 50px)",
                            width: "1px",
                            height: "1px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundClip: "unset",
                            position: "absolute",
                            transform: this.state.isLoadingProducts ? "rotateX(180deg)" : undefined
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Loader */.aN, {})
                    }),
                    this.isTourReadyForAudio() && showcaseLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar, {
                        showPathSwitch: (game === null || game === void 0 ? void 0 : (ref3 = game.paths) === null || ref3 === void 0 ? void 0 : ref3.length) > 1,
                        whiteLabelData: whiteLabelData,
                        onHelpClick: this.onHelpClick,
                        contactPhone: (ref4 = this.state.tourEmail) === null || ref4 === void 0 ? void 0 : ref4.contactPhone,
                        menuVisible: menuOpen,
                        toggleMenu: this.toggleMenu,
                        gameBookVisible: showBook,
                        showGameBook: (game === null || game === void 0 ? void 0 : game.gameBookOn) && (game === null || game === void 0 ? void 0 : game.book),
                        panoramaOn: panoramaOn,
                        isTourReadyForAudio: this.isTourReadyForAudio,
                        minimapVisible: minimapVisible,
                        vsObjects: this.vsObjects,
                        isVSEnabled: isVSEnabled,
                        toggleVS: this.toggleVS,
                        isHasFloorMusic: isHasFloorMusic,
                        mainPlaying: mainPlaying,
                        translation: translation,
                        tourEmail: tourEmail,
                        tour: tour,
                        sharePopupOn: sharePopupOn,
                        tourType: tourType,
                        cartProducts: cartProducts,
                        showMinimapClick: this.showMinimapClick,
                        toggleContactPopup: this.toggleContactPopup,
                        toggleAppointmentsModal: this.toggleAppointmentsModal,
                        openCart: this.openCart,
                        openStore: this.openStore,
                        openShare: this.openShare,
                        onStartVideo: this.startVideo,
                        onStopVideo: this.stopVideo,
                        takeScreenshot: this.takeScreenshot,
                        handleToggleMusic: this.handleToggleMusic,
                        getSetting: this.getSetting,
                        toggleGameBook: this.toggleGameBook,
                        menuWidth: this.state.menuWidth
                    }),
                    !isShowProduct && !isShowProducts && !panoramaOn && !cartOpen && !checkoutOpen && !contactMeOpen && !successPurchaseScreenOpen && storeOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Store, {
                        settings: settings,
                        rtl: tour === null || tour === void 0 ? void 0 : (ref5 = tour.client) === null || ref5 === void 0 ? void 0 : ref5.rtl,
                        tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                        userId: tour === null || tour === void 0 ? void 0 : tour.userId,
                        productTypes: (ref6 = this) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.state) === null || ref7 === void 0 ? void 0 : ref7.productTypes,
                        onChangeFavourite: this.onChangeToFavorite,
                        favoriteProductsIds: this.state.favoriteProductsIds,
                        products: products,
                        filterOptions: this.state.menuFilterOptions,
                        currency: currency,
                        translation: translation,
                        onClose: this.closeStore,
                        openProduct: this.openProduct,
                        setMenuData: function(menusData) {
                            return _this.setState((0,_object_spread/* default */.Z)({}, menusData));
                        },
                        getProductsWithPagination: this.setProductsWithPagination,
                        storeProducts: this.state.products,
                        pageSize: this.state.pageSize,
                        isLoadingProducts: this.state.isLoadingProducts
                    }),
                    !panoramaOn && isShowProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPopup, {
                        panoramaOn: panoramaOn,
                        isLoadingProduct: this.state.isLoadingProduct,
                        closeProductPopup: this.closeProductPopup,
                        rtl: tour.client && tour.client.rtl,
                        currentProduct: this.state.currentProduct,
                        whiteLabel: whiteLabelData,
                        logo: (tour === null || tour === void 0 ? void 0 : (ref8 = tour.client) === null || ref8 === void 0 ? void 0 : ref8.withLogo) ? "".concat("https://cdn.treedis.com", "/clients/").concat(tour.client.id, "/logo.png") : null,
                        cartProducts: cartProducts,
                        onAddToCart: this.onAddToCart,
                        openCart: this.openCartAndCloseModal,
                        openProduct: this.openProductWithDelay,
                        onChangeFavorite: this.onChangeToFavorite,
                        favoriteProductsIds: this.state.favoriteProductsIds,
                        currency: currency,
                        translation: translation,
                        settings: settings,
                        userId: tour.userId,
                        tourId: tour.id,
                        onChangeCart: this.onChangeCart,
                        handleLoadingProduct: function(state) {
                            return _this.setState({
                                isLoadingProduct: state
                            });
                        },
                        isFromCart: isFromCart,
                        openedCartProductId: openedCartProductId,
                        isShowProduct: isShowProduct
                    }),
                    !contactMeOpen && !checkoutOpen && cartOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPopup, {
                        whitelabel: whiteLabelData,
                        matterId: tour.matterId,
                        client: tour.client,
                        cartProducts: cartProducts,
                        shippingProfiles: this.state.shippingProfiles,
                        countries: this.state.countries,
                        rtl: tour === null || tour === void 0 ? void 0 : (ref9 = tour.client) === null || ref9 === void 0 ? void 0 : ref9.rtl,
                        currency: currency,
                        translation: translation,
                        tour: tour,
                        settings: settings,
                        locations: this.state.locations,
                        favoriteProductsIds: this.state.favoriteProductsIds,
                        onClose: this.closeCart,
                        onChangeCart: this.onChangeCart,
                        clearCart: this.clearCart,
                        openCheckout: this.openCheckout,
                        openContactMe: this.openContactMe
                    }),
                    !contactMeOpen && checkoutOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkout, {
                        tourSlug: tour === null || tour === void 0 ? void 0 : tour.slug,
                        rtl: tour === null || tour === void 0 ? void 0 : (ref10 = tour.client) === null || ref10 === void 0 ? void 0 : ref10.rtl,
                        clientPaypalId: tour === null || tour === void 0 ? void 0 : (ref11 = tour.client) === null || ref11 === void 0 ? void 0 : ref11.paypalClientId,
                        countries: this.state.countries,
                        currency: currency,
                        locations: this.state.locations,
                        cartProducts: cartProducts,
                        translation: translation,
                        settings: settings,
                        onClose: this.closeCheckout,
                        onBack: this.backCheckout,
                        openContactMe: this.openContactMe,
                        clearOrder: this.clearCart,
                        openSuccessPurchaseScreen: this.openSuccessPurchaseScreen
                    }),
                    contactMeOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactMe, {
                        settings: settings,
                        rtl: tour === null || tour === void 0 ? void 0 : (ref12 = tour.client) === null || ref12 === void 0 ? void 0 : ref12.rtl,
                        currency: currency,
                        tourSlug: tour === null || tour === void 0 ? void 0 : tour.slug,
                        translation: translation,
                        countries: this.state.countries,
                        cartProducts: cartProducts,
                        onClose: this.closeContactMe,
                        contactMeType: this.state.contactMeType,
                        contactMeIframeLink: this.state.contactMeIframeLink,
                        contactMeRequiredFields: this.state.contactMeRequiredFields
                    }),
                    successPurchaseScreenOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessPurchaseScreen, {
                        translation: translation,
                        closeSuccessPurchaseScreen: this.closeSuccessPurchaseScreen
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Header, {
                        tour: tour,
                        translation: translation,
                        logoUrl: this.getLogoUrl(),
                        chatToken: chatToken
                    }),
                    isShowProducts && !panoramaOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Products, {
                        rtl: tour.client && tour.client.rtl,
                        theme: settings === null || settings === void 0 ? void 0 : settings.theme,
                        onClose: this.closeProductsPopup,
                        products: currentProducts,
                        lastClickedItem: this.lastClickedItem,
                        onClick: function(product) {
                            return _this.setState({
                                currentProduct: product
                            });
                        },
                        openProduct: this.openProduct,
                        onChangeFavourite: this.onChangeToFavorite,
                        favoriteProductsIds: this.state.favoriteProductsIds,
                        currency: currency
                    }),
                    tour.hideSidebarConfigs && /*#__PURE__*/ (0,jsx_runtime.jsx)(BbWhitelabelBlock, {
                        translation: translation,
                        whiteLabel: whiteLabelData,
                        tour: tour,
                        onHelpClick: this.onHelpClick
                    })
                ]
            })
        }));
    };
    return ECommerceTour;
}(BaseTour/* default */.Z);



/***/ })

}]);